module.exports = __webpack_public_path__ + "h5/img/cs_08.a1a0fbd8.jpeg";